<template>
  <h4 class="modal__title" v-html="title" />
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * 共通 モーダルタイトル テンプレート
 */
export default defineComponent({
  name: 'ModalTitleParts',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.modal__title {
  width: 100%;
  text-align: center;
  @include fontSetTextMedium(17);

  &:first-child {
    margin-top: 36px;
  }
}
</style>
